module.exports = __webpack_public_path__ + "static/img/JiuXiang_Banner_autumn.363944b4.jpg";